import React from 'react';
import PropTypes from 'prop-types';
import styles from './SideArticleCard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import placeholderImage from '../PFSArticleCard/empty.png';
import LoadingImage from '../LoadingImage/LoadingImage';

const SideArticleCard = ({ image, title, publishedAt, articleSlug }) => {
  return (
    <div className={styles.SideArticleCard} data-testid='SideArticleCard'>
      <Link to={`/articles/${articleSlug ?? ''}`}>
        <LoadingImage
          placeholderImage={placeholderImage}
          image={image}
          styleclass={styles.ArticleImage}
          altText='Article'
        />
      </Link>
      <div>
        <p className={styles.ArticleTitle} data-testid='SideCardTitle'>
          <Link to={`/articles/${articleSlug ?? ''}`}>{title}</Link>
        </p>

        <div className={styles.ArticleInfo}>
          <div data-testid='SideCardPublishedDate'>
            <FontAwesomeIcon className={styles.icon} icon={faCalendarDays} />
            {publishedAt ? new Date(publishedAt).toUTCString().slice(0, -13) : '-'}
          </div>
        </div>
      </div>
    </div>
  );
};

SideArticleCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  publishedAt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]).isRequired,
  articleSlug: PropTypes.string.isRequired,
};

export default SideArticleCard;
